
/**
 * list 转 String
 * @param {*} ls
 */
export const list2string = (ls)=>{
  if(!ls){
    return "";
  }
  return ls.join(",");
}

/**
 * 解析图形JSON中的f$标志为字符串
 * @param json
 */
export const loopChartJson = (json)=>{
  const exec = (jsons)=>{
    for(let key in jsons) {
      let o = jsons[key];
      if(typeof o  === 'object'){
        exec(o);  //如果是Object则递归
      }else if(typeof o === 'string'){
        if(o.indexOf&&o.indexOf('f$')>-1){  //吧f$字符串解析成函数
          jsons[key] = eval("("+o.replace("f$", "")+")");
        }
      }
      //else if(typeof o === 'number'){

      //}
    }
  }
  exec(json);
  ////console.log("loopChartJson----------")
  ////console.log(json.toString())


  return json;
}

export const formatDate = function(date, fmt){
  var o = {
    "M+" : date.getMonth()+1,                 //月份
    "d+" : date.getDate(),                    //日
    "H+" : date.getHours(),                   //小时
    "m+" : date.getMinutes(),                 //分
    "s+" : date.getSeconds(),                 //秒
    "q+" : Math.floor((date.getMonth()+3)/3), //季度
    "S"  : date.getMilliseconds()             //毫秒
  };
  if(/(y+)/.test(fmt)) {
    fmt=fmt.replace(RegExp.$1, (date.getFullYear()+"").substr(4 - RegExp.$1.length));
  }
  for(var k in o) {
    if(new RegExp("("+ k +")").test(fmt)){
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
    }
  }
  return fmt;
};

/**
 * 是否移动端检查
 */
export const isMobile =()=> {
  let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
  if (flag) {
    return true;
  } else {
    return false;
  }
}

//数字格式化
export const formatNumber = function (num, pattern, shortname){
  if (!pattern || pattern.length == 0) {
    return num;
  }
  var negative = false; //负数
  if (num < 0) {
    num = Math.abs(num);
    negative = true;
  }
  var shortdw;
  if (shortname && num > 100000000) {
    num = num / 100000000;
    shortdw = "亿";
  } else if (shortname && num > 10000000) {
    num = num / 10000000;
    shortdw = "千万";
  } else if (shortname && num > 1000000) {
    num = num / 1000000;
    shortdw = "百万";
  } else if (shortname && num > 10000) {
    num = num / 10000;
    shortdw = "万";
  } else if (shortname && num > 1000) {
    num = num / 1000;
    shortdw = "千";
  }
  if (pattern.indexOf("%") <= 0 && shortname) {
    return (
      (negative ? "-" : "") +
      Math.round(num * 10) / 10 +
      (shortdw ? shortdw : "")
    );
  }
  if (pattern.indexOf("%") > 0) {
    num = num * 100;
  }
  var fmtarr = pattern ? pattern.split(".") : [""];
  var retstr = "";

  //先对数据做四舍五入
  var xsw = 0;
  if (fmtarr.length > 1) {
    xsw = fmtarr[1].length;
  }
  var bl = 1;
  for (i = 0; i < xsw; i++) {
    bl = bl * 10;
  }
  num = num * bl;
  num = Math.round(num);
  num = num / bl;

  var strarr = num ? num.toString().split(".") : ["0"];

  // 整数部分
  var str = strarr[0];
  var fmt = fmtarr[0];
  var i = str.length - 1;
  var comma = false;
  for (var f = fmt.length - 1; f >= 0; f--) {
    switch (fmt.substr(f, 1)) {
      case "#":
        if (i >= 0) retstr = str.substr(i--, 1) + retstr;
        break;
      case "0":
        if (i >= 0) retstr = str.substr(i--, 1) + retstr;
        else retstr = "0" + retstr;
        break;
      case ",":
        comma = true;
        retstr = "," + retstr;
        break;
    }
  }
  if (i >= 0) {
    if (comma) {
      var l = str.length;
      for (; i >= 0; i--) {
        retstr = str.substr(i, 1) + retstr;
        if (i > 0 && (l - i) % 3 == 0) retstr = "," + retstr;
      }
    } else retstr = str.substr(0, i + 1) + retstr;
  }

  retstr = retstr + ".";
  // 处理小数部分
  str = strarr.length > 1 ? strarr[1] : "";
  fmt = fmtarr.length > 1 ? fmtarr[1] : "";
  i = 0;
  for (var f = 0; f < fmt.length; f++) {
    switch (fmt.substr(f, 1)) {
      case "#":
        if (i < str.length) retstr += str.substr(i++, 1);
        break;
      case "0":
        if (i < str.length) retstr += str.substr(i++, 1);
        else retstr += "0";
        break;
    }
  }

  var r = retstr.replace(/^,+/, "").replace(/\.$/, "");
  if (pattern.indexOf("%") > 0) {
    r = r + "%";
  }
  if (shortdw) {
    r = r + shortdw;
  }
  if (negative) {
    r = "-" + r;
  }
  return r;
}

